"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function getFilterString(prefix, value) {
    return prefix + value + ",";
}
function cloudinarize(imgSrc, cloudinaryFilters) {
    if (!imgSrc) {
        return undefined;
    }
    var imageURL = imgSrc;
    if (imgSrc && imgSrc.startsWith("http://res.cloudinary.com/")) {
        imageURL = imgSrc.replace("http", "https");
    }
    if (!imageURL.includes("/image/upload") && !imageURL.includes("avatars")) {
        return imageURL;
    }
    var defaultCloudinaryFilters = {
        crop: "lfill",
        qualityAuto: "good",
        format: "auto",
        dpr: "2.0",
        gravity: "auto:faces",
    };
    var allFilters = __assign(__assign({}, defaultCloudinaryFilters), (cloudinaryFilters || {}));
    var filtersAsString = Object.entries(allFilters).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        switch (key) {
            case "height":
                return acc + getFilterString("h_", value);
            case "width":
                return acc + getFilterString("w_", value);
            case "quality":
                return acc + getFilterString("q_", value);
            case "qualityAuto":
                return acc + getFilterString("q_auto:", value);
            case "format":
                return acc + getFilterString("f_", value);
            case "crop":
                return acc + getFilterString("c_", value);
            case "dpr":
                return acc + getFilterString("dpr_", value);
            case "gravity":
                return acc + getFilterString("g_", value);
            case "round":
                return acc + getFilterString("r_", value);
            default:
                return acc;
        }
    }, "");
    if (imageURL.includes("/image/upload")) {
        var cutIndex = imageURL.indexOf("/image/upload") + 14;
        return "" + imageURL.slice(0, cutIndex) + filtersAsString + "/" + imageURL.slice(cutIndex);
    }
    return "https://res.cloudinary.com/kinside/image/upload/" + filtersAsString + "/v1/" + imageURL;
}
exports.default = cloudinarize;
